import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
import _imports_0 from '@/assets/images/no-picture.png';
const _hoisted_1 = {
  class: "programm-list-page"
};
const _hoisted_2 = {
  class: "wrap white-bg"
};
const _hoisted_3 = {
  class: "tab-wrap"
};
const _hoisted_4 = {
  class: "tab-wrap-left"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "tab-wrap-right"
};
const _hoisted_7 = {
  class: "category-selector"
};
const _hoisted_8 = {
  key: 0,
  "infinite-scroll-delay": 1000,
  "infinite-scroll-distance": 20,
  "infinite-scroll-immediate": false,
  class: "list-wrap my-scroller"
};
const _hoisted_9 = {
  class: "list-item-header"
};
const _hoisted_10 = {
  class: "left"
};
const _hoisted_11 = {
  class: "list-item-footer"
};
const _hoisted_12 = {
  class: "left"
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = {
  class: "right"
};
const _hoisted_16 = {
  key: 0,
  class: "no-more-data"
};
import ProgramDetailsDialog from './components/ProgramDetailsDialog.vue';
import EditCreateProgramDialog from './components/EditCreateProgramDialog.vue';
import CreateProgramDialog from './components/CreateProgramDialog.vue';
import { reactive, ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getAppLiveProgramPage } from '@/request/program';
import { getCategories } from '@/request/index.ts';
import { getAppInteractiveList, addAppLiveProgram, queryProject, deleteAppLiveProgram } from '@/request/index';
import CategoriesDialog from './components/CategoriesDialog.vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import 'element-plus/es/components/message/style/index'
import 'element-plus/es/components/message-box/style/index'

import { getToken } from '@/api';
import { useMainStore } from '@/pinia';

// ref

export default {
  __name: 'programmlist',
  setup(__props) {
    const editCreateProgramDialog = ref(null); //编辑节目弹窗
    const programDetailDialog = ref(null); //节目详情弹窗
    const categoriesDialog = ref(null); //分类维护弹窗
    const createProgramDialog = ref(null); //新建节目弹窗

    // data
    const interactiveList = ref([]); // 互动列表
    const categoriesOptions = ref([]); // 分类下拉菜单的选项
    const listPageIndex = ref(1); // 列表页码
    const listPageSize = ref(20); // 列表每页数量
    const listNoMore = ref(false); // 列表没有更多数据
    const loading = ref(false); // 列表加载中
    const lists = ref([]); // 列表
    const activeName = ref(''); // 当前选中的分类名称
    const router = useRouter();
    const store = useMainStore();
    const selectedCategory = ref(null);
    const tabs = ref([
    /* {
      label:'视频节目',
      value:'2'
    }, */
    {
      label: '直播节目',
      value: '1'
    }]);
    const activeTab = ref('1'); // 当前选中的tab

    onMounted(() => {
      categories();
    });

    // 时间格式化
    const formatDate = dateString => {
      const date = new Date(dateString);
      const year = date.getFullYear().toString().slice(-2); // 获取最后两位年份
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，加1并确保两位数
      const day = date.getDate().toString().padStart(2, '0'); // 日期确保两位数

      return `${year}-${month}-${day}`; // 格式为 'yy-mm-dd'
    };

    // 格式化秒数为时间
    const formatSecondsToTime = seconds => {
      let milliseconds = seconds * 1000; // 转换为毫秒
      let hours = Math.floor(milliseconds / (1000 * 60 * 60));
      let minutes = Math.floor(milliseconds % (1000 * 60 * 60) / (1000 * 60));
      let remainingSeconds = Math.floor(milliseconds % (1000 * 60) / 1000);
      let millisecondsRemainder = milliseconds % 1000;

      // 确保小时、分钟、秒和毫秒始终显示两位数（对于小时，可能需要显示一位或两位）
      hours = String(hours).padStart(2, '0');
      minutes = String(minutes).padStart(2, '0');
      remainingSeconds = String(remainingSeconds).padStart(2, '0');
      millisecondsRemainder = String(millisecondsRemainder).substring(0, 3).padStart(3, '0');
      return `${hours}:${minutes}:${remainingSeconds}.${millisecondsRemainder}`;
    };

    // 获取分类
    const categories = async () => {
      try {
        const response = await getCategories({
          pageIndex: 1,
          // 调整为0-based索引
          pageSize: 99999
        });
        // 填充下拉菜单的选项
        categoriesOptions.value = response.data.data.list.map(val => ({
          label: val.name,
          value: val.id
        }));
        categoriesOptions.value.unshift({
          label: '全部',
          value: ''
        });
      } catch (error) {
        console.error(error);
        ElMessage({
          message: '获取分类失败,请刷新界面',
          type: 'error'
        });
      }
    };

    // 切换tab
    const toggleTab = tab => {
      activeTab.value = tab.value;
      getData();
    };

    // 初始化
    onMounted(async () => {
      const data = await getData();
      lists.value = data.list;
    });

    // 跳转到新建节目
    const gotoAdd = () => {
      if (activeTab.value == '2') {
        router.push({
          path: '/new-video',
          query: {
            type: 'programm',
            programType: activeTab.value
          }
        });
      } else {
        // newVisible.value = true;
        // 默认帮他选中分类
        createProgramDialog.value.openDialog({
          categoriesId: activeName.value
        });
        getInteractiveData();
      }
    };

    // 跳转到分类维护
    const manageCategories = () => {
      // categoriesVisible.value = true;
      categoriesDialog.value.openCategories();
    };
    const getInteractiveData = () => {
      getAppInteractiveList().then(res => {
        const {
          data
        } = res.data;
        interactiveList.value = data;
      });
    };

    // 编辑节目成功
    const editProgramSuccess = async () => {
      listPageIndex.value = 1;
      listNoMore.value = false;
      const data = await getData();
      lists.value = data.list;
    };

    // 添加节目成功
    const addProgramSuccess = async () => {
      listPageIndex.value = 1;
      listNoMore.value = false;
      const data = await getData();
      lists.value = data.list;
    };

    // 打开编辑节目弹窗
    const openEditProgramDialog = val => {
      editCreateProgramDialog.value.openDialog(val);
    };

    // 打开分类详情弹窗
    const openProgramDetailDialog = val => {
      programDetailDialog.value.openDialog(val);
    };

    // 点击分类
    const handleClickCategory = async val => {
      listPageIndex.value = 1;
      listNoMore.value = false;
      selectedCategory.value = val.paneName;
      const data = await getData();
      lists.value = data.list;
    };

    // 加载更多
    const load = async () => {
      if (listNoMore.value) {
        return;
      }
      if (!listNoMore.value) {
        loading.value = true;
      }
      ++listPageIndex.value;
      const data = await getData();
      // 如果实际请求的数量少于当前数量，说明没有更多数据了
      if (data.list.length < listPageSize.value) {
        listNoMore.value = true;
      }
      lists.value = [...lists.value, ...data.list];
      loading.value = false;
    };

    // 获取列表
    const getData = async () => {
      try {
        loading.value = true;
        const res = await getAppLiveProgramPage({
          pageIndex: listPageIndex.value,
          pageSize: listPageSize.value,
          liveType: activeTab.value == 2 ? 1 : 2,
          categoriesId: selectedCategory.value
        });
        const {
          data
        } = res.data;
        return data;
      } catch (error) {
        ElMessage({
          message: '获取列表失败,请刷新界面',
          type: 'error'
        });
      } finally {
        setTimeout(() => {
          loading.value = false;
        }, 500);
      }
    };

    // 删除节目
    const handleDelete = id => {
      ElMessageBox.confirm('将删除此节目，是否继续？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(async () => {
        // 删除节目
        const res = await deleteAppLiveProgram(id);
        const {
          code,
          msg
        } = res.data;
        ElMessage({
          type: code == 200 ? 'success' : 'error',
          message: msg
        });
        const data = await getData();
        lists.value = data.list;
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_image = _resolveComponent("el-image");
      const _component_Search = _resolveComponent("Search");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_Delete = _resolveComponent("Delete");
      const _component_Edit = _resolveComponent("Edit");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_empty = _resolveComponent("el-empty");
      const _directive_infinite_scroll = _resolveDirective("infinite-scroll");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, item => {
        return _openBlock(), _createElementBlock("a", {
          class: _normalizeClass(["tab-item", activeTab.value == item.value && 'active']),
          key: item.value,
          onClick: $event => toggleTab(item)
        }, _toDisplayString(item.label), 11, _hoisted_5);
      }), 128))]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
        size: "default",
        class: "category-btn btn-wrap",
        type: "primary",
        onClick: manageCategories
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("分类维护")])),
        _: 1
      }), _createVNode(_component_el_button, {
        size: "default",
        class: "add-btn btn-wrap",
        type: "primary",
        onClick: gotoAdd
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("新建节目")])),
        _: 1
      })])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_tabs, {
        size: "default",
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeName.value = $event),
        class: "category-tabs-box",
        onTabClick: handleClickCategory
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoriesOptions.value, category => {
          return _openBlock(), _createBlock(_component_el_tab_pane, {
            key: category.value,
            label: category.label,
            name: category.value
          }, null, 8, ["label", "name"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), lists.value.length > 0 ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_row, {
        gutter: 10
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lists.value, item => {
          return _openBlock(), _createBlock(_component_el_col, {
            xs: 24,
            sm: 12,
            md: 8,
            lg: 4,
            xl: 4,
            class: "list-item-wrap",
            key: item.id
          }, {
            default: _withCtx(() => [_createVNode(_component_el_card, {
              class: "list-item",
              shadow: "never"
            }, {
              header: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", null, _toDisplayString(item.name), 1)]), _cache[4] || (_cache[4] = _createElementVNode("div", {
                class: "right"
              }, null, -1))])]),
              footer: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [activeTab.value == '2' ? (_openBlock(), _createElementBlock("span", _hoisted_13, "节目时长：" + _toDisplayString(formatSecondsToTime(item.videoMakeDuration)) + " " + _toDisplayString(item.createTime), 1)) : _createCommentVNode("", true), activeTab.value == '1' ? (_openBlock(), _createElementBlock("span", _hoisted_14, "创建时间：" + _toDisplayString(formatDate(item.createTime)), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_dropdown, {
                size: "default"
              }, {
                dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                    onClick: $event => openProgramDetailDialog(item)
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_component_Search)]),
                      _: 1
                    }), _cache[6] || (_cache[6] = _createTextVNode("查看详情"))]),
                    _: 2
                  }, 1032, ["onClick"]), _createVNode(_component_el_dropdown_item, {
                    onClick: $event => handleDelete(item.id)
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_component_Delete)]),
                      _: 1
                    }), _cache[7] || (_cache[7] = _createTextVNode("删除"))]),
                    _: 2
                  }, 1032, ["onClick"]), _createVNode(_component_el_dropdown_item, {
                    onClick: $event => openEditProgramDialog(item)
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_component_Edit)]),
                      _: 1
                    }), _cache[8] || (_cache[8] = _createTextVNode("编辑"))]),
                    _: 2
                  }, 1032, ["onClick"])]),
                  _: 2
                }, 1024)]),
                default: _withCtx(() => [_createElementVNode("i", {
                  class: "el-dropdown-link ri-list-unordered",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                })]),
                _: 2
              }, 1024)])])]),
              default: _withCtx(() => [_createVNode(_component_el_image, {
                class: "list-item-image",
                src: item.backgroundUrl || undefined,
                "zoom-rate": 1.2,
                "max-scale": 7,
                "min-scale": 0.2,
                "initial-index": 4,
                "preview-src-list": [item.backgroundUrl],
                fit: "cover"
              }, {
                error: _withCtx(() => _cache[5] || (_cache[5] = [_createElementVNode("div", {
                  class: "image-slot"
                }, [_createElementVNode("img", {
                  src: _imports_0
                }), _createElementVNode("div", {
                  class: "no-image-text"
                }, "暂无封面图")], -1)])),
                _: 2
              }, 1032, ["src", "preview-src-list"])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }), listNoMore.value ? (_openBlock(), _createElementBlock("div", _hoisted_16, " 没有更多数据了.... ")) : _createCommentVNode("", true)])), [[_directive_infinite_scroll, load]]) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        class: "empty-wrap",
        description: "还未找到相关节目，快去新建节目吧"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: gotoAdd
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("新建节目")])),
          _: 1
        })]),
        _: 1
      }))])), [[_directive_loading, loading.value]]), _createVNode(ProgramDetailsDialog, {
        ref_key: "programDetailDialog",
        ref: programDetailDialog,
        onOpenEditProgramDialog: openEditProgramDialog
      }, null, 512), _createVNode(CategoriesDialog, {
        ref_key: "categoriesDialog",
        ref: categoriesDialog,
        onRefreshCategories: categories
      }, null, 512), _createVNode(CreateProgramDialog, {
        ref_key: "createProgramDialog",
        ref: createProgramDialog,
        onAddProgramSuccess: addProgramSuccess
      }, null, 512), _createVNode(EditCreateProgramDialog, {
        ref_key: "editCreateProgramDialog",
        ref: editCreateProgramDialog,
        onEditProgramSuccess: editProgramSuccess
      }, null, 512)]);
    };
  }
};